import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import flechaAvanzar from "../assets/right-arrow.svg";
import { updateScenario, updateTime } from "../redux/actions";
import { getTimer, updateStats } from "../utils/helpers";

const TEXT_CLASS = { orange: "orange", violet: "violet", blue: "blue", green: "green" };
const BG_CLASS   = { orange: "bgOrange", violet: "bgViolet", blue: "bgBlue", green: "bgGreen" };

function NextButton({
  navigateTo,
  navigateToAfter,
  activeScenario,
  color,              // "orange" | "violet" | "blue" | "green"
  textColor,
  className = "",     // <-- nuevo
  loading,            // <-- controlado opcional
  canGoNext = true,
  lockedTitle = "Disponible al terminar", // opcional
  ...rest             // <-- para data-*, aria-*, etc.
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const group = useSelector((state) => state.group);
  const scenario = activeScenario || location?.state?.activeScenario;

  // estado interno si no te pasan 'loading' desde fuera
  const [internalLoading, setInternalLoading] = useState(false);
  const isLoading = loading ?? internalLoading;

  async function handleNext(e) {
    e.preventDefault();
    if (isLoading || !canGoNext) return;

    setInternalLoading(true);

    const time = getTimer();
    dispatch(updateTime(time));
    dispatch(updateScenario(scenario));
    updateStats({
      ...group,
      actualScenario: scenario || group?.actualScenario,
      time,
      lastVisited: navigateTo,
    });

    // Deja que React pinte el aro antes de navegar (un frame)
    await new Promise((r) => requestAnimationFrame(() => r()));

    navigate(navigateTo, {
      state: { navigateTo: navigateToAfter, activeScenario: scenario },
    });
  }

  const textClass = textColor ? TEXT_CLASS[textColor] || "" : color ? TEXT_CLASS[color] || "" : "txtRed";
  const btnBgClass = color ? BG_CLASS[color] || "" : "";

  return (
    <div className="d-flex justify-content-end align-items-center">
      <div className={`txtBotones bold me-3 ${textClass}`}>Siguiente</div>
      <button
        type="button"
        onClick={handleNext}
        className={`btn-main ${btnBgClass} btn-progress ${color}`}
        data-loading={isLoading ? "true" : "false"}
        style={{ width: 80, height: 80, borderRadius: "50%", opacity: canGoNext ? 1 : 0.6, cursor: canGoNext ? "pointer" : "not-allowed" }}
        aria-label="Siguiente"
        aria-busy={isLoading}
        disabled={!canGoNext || isLoading}   // <- deshabilita nativo (teclado y ratón)
        title={!canGoNext ? lockedTitle : undefined}
        {...rest}
      >
        <img src={flechaAvanzar} alt="" style={{ maxWidth: 40 }} />
      </button>
    </div>
  );
}

export default NextButton;
